import React = require('react');

export interface EditGroupDialogLabelStyleProps {
    message: string;
    style: React.CSSProperties;
}

export function EditGroupDialogLabel(props: EditGroupDialogLabelStyleProps): JSX.Element {
    return <div style={props.style}><span>{props.message}</span></div>;
}